(ns ycweb.util.markdown.html
  (:require
    [util.string :as str]
    [hickory.core :as hickory]))

(defn escape-string [s]
  (->
    s
    (str/replace #"[*]" "\\*")
    (str/replace #"[-]" "\\-")
    (str/replace #"[`]" "\\`")
    (str/replace #"[_]" "\\_")
    (str/replace #"[#]" "\\#")
    (str/replace #"[!]" "\\!")
    (str/replace #"[\[]" "\\[")
    (str/replace #"[\]]" "\\]")
    (str/replace #"[\(]" "\\(")
    (str/replace #"[\)]" "\\)")
    (str/replace #"[\{]" "\\{")
    (str/replace #"[\}]" "\\}")))

;; This implmentation uses the stack for recursion, so isn't
;; suited to massively nested documents.
;; Like... 8000+ deep divs are going to give issues.
;; I'm sure it's fine.
(defn walk-hickory [fragment state]
  (cond
    (nil? fragment) nil
    ;; TODO: Escape characters
    ;; https://www.markdownguide.org/basic-syntax/#characters-you-can-escape
    (string? fragment) (escape-string fragment)
    (or (seq? fragment) (vector? fragment) (list? fragment))
    (apply str (map walk-hickory fragment))

    (map? fragment)
    (let [content (walk-hickory (:content fragment) state)
          attrs (:attrs fragment)]
      (case (:tag fragment)
        :b (str "*" content "*")
        :i (str "_" content "_")
        :strong (str "**" content "**")
        :br (str "\r\n")
        :a (str "[" content "](" (:href attrs) (if (:title attrs) (str " \"" (:title attrs) "\"")) ")")
        :img (str "![" (:alt attrs) "](" (:src attrs) ")")
        :code (str "`" content "`")

        ;; TODO: add other handling here
        ;; Need at least ul and ol support.
        ;; But it needs to track state, including indentation level and
        ;; numbered bullets
        ;;
        ;; Also need blockquote support, particularly nested blockquotes.

        ;; Also multiline code support...
        content))

    ;; Fallback, shouldn't be needed.
    :else nil))

(defn html->markdown [html]
  (walk-hickory
    (map hickory/as-hickory (hickory/parse-fragment html))
    {}))
